
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advocacy/policy-making/naic",
      function () {
        return require("private-next-pages/advocacy/policy-making/naic.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advocacy/policy-making/naic"])
      });
    }
  